/**
 * Compares dotted numeric version strings ("2.1.0" vs "2.1"). Missing parts
 * count as 0 and non-numeric parts as 0. Returns a negative number when a < b,
 * positive when a > b, 0 when equal.
 */
export function compareVersions(a: string, b: string): number {
    const pa = a.split('.').map(n => parseInt(n, 10) || 0);
    const pb = b.split('.').map(n => parseInt(n, 10) || 0);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
        if (diff !== 0) return diff;
    }
    return 0;
}
